export default {
    id: {
        type: Number,
        required: true,
    },

    configuration: {
        type: Object,
        required: true,
    },

    content: {
        required: true,
    },

    isLoading: {
        type: Boolean,
        required: true,
    },

    isExpanded: {
        type: Boolean,
        required: true,
    },

    isPrintver: {
        type: Boolean,
        required: false,
    },

    widgetType: {
        type: Number,
        required: true,
    },

    widgetLastUpdated: {
        required: true,
    },
};
